import { inject, Injectable } from '@angular/core';
import { Api, Response } from '@fry-it/risr-core';

export interface SearchResponse {
  ids: string[];
  size: number;
  total: number;
  start: number;
}

export interface FetchResponse {
  docs: any[];
}

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private api = inject(Api);

  async search(text: string): Promise<Response<SearchResponse>> {
    return this.api.post<SearchResponse>(`/v2/users/search`, {fullname: text});
  }

  async fetch(ids: string[]): Promise<any[]> {
    const response = await this.api.post<FetchResponse>(`/v2/users/fetch`, { ids });
    return response.data?.docs || [];
  }

  async fetchByUsername(username: string): Promise<any> {
    const response = await this.api.get<FetchResponse>(`/v2/users/by_username/${username}`);
    return response.data || null;
  }


}
